import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LogoComponentComponent } from "../../base-components/logo-component/logo-component.component";

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [LogoComponentComponent],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent{
  
}
